<template>
  <div>
    <Accordion
      :is-open="false"
      class="pega-visible"
    >
      <template #head>
        絞り込み項目
      </template>
      <template #body>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div>
            <div class="boss-table-3">
              <div class="boss-table-3-item">
                <div class="boss-table-3-head">
                  会員ID
                </div>
                <div class="boss-table-3-body" />
                <input
                  v-model.number="matchKeyObject.applicant.user.id.prefix"
                  class="boss-input boss-input-fill"
                  data-test="input-user-id"
                  type="number"
                  :max="Number.MAX_SAFE_INTEGER"
                  min="0"
                  @keypress="onlyNumberInRange($event)"
                >
              </div>
              <div class="boss-table-3-item">
                <div class="boss-table-3-head">
                  氏名
                </div>
                <div class="boss-table-3-body">
                  <input
                    v-model="fuzzyKeyObject.name.value"
                    type="text"
                    class="boss-input boss-input-fill"
                    data-test="input-full-name"
                  >
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  性別
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="equalKeyObject.applicant.user.gender.id"
                    class="boss-input-select"
                    data-test="select-gender"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="gender in genderMaster"
                      :key="gender.id"
                      :value="gender.id"
                    >
                      {{ gender.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  年齢
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="ageGte"
                    class="boss-input-select"
                    data-test="select-age-gte"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(age, i) in ageOptions"
                      :key="i"
                      :value="age"
                    >
                      {{ age }}
                    </option>
                  </select>
                  <span>歳</span>
                  〜
                  <select
                    v-model="ageLte"
                    class="boss-input-select"
                    data-test="select-age-lte"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(age, i) in ageOptions"
                      :key="i"
                      :value="age"
                    >
                      {{ age }}
                    </option>
                  </select>
                  <span>歳</span>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc pega-visible">
                <div class="boss-table-3-head">
                  応募日
                </div>
                <div class="boss-table-3-body">
                  <date-picker
                    v-model="rangeKeyObject.applicant.entryDate.gte"
                    type="date"
                    format="YYYY-MM-DD"
                    :disabled-date="notAfterTodayAndBeforeExpiryDate"
                    :editable="false"
                    input-class="pega-picker"
                    value-type="format"
                    data-test="data-picker-from"
                    placeholder="日付を選択"
                    :style="{ width: 'auto' }"
                    @clear="$set(rangeKeyObject.applicant.entryDate,'gte' ,'')"
                  />
                  〜
                  <date-picker
                    v-model="rangeKeyObject.applicant.entryDate.lte"
                    type="date"
                    format="YYYY-MM-DD"
                    :disabled-date="notAfterTodayAndBeforeExpiryDate"
                    :editable="false"
                    input-class="pega-picker"
                    value-type="format"
                    data-test="data-picker-to"
                    placeholder="日付を選択"
                    :style="{ width: 'auto' }"
                    @clear="$set(rangeKeyObject.applicant.entryDate,'lte' ,'')"
                  />
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  <input
                    id="is-casual-interview-request"
                    v-model="equalKeyObject.applicant.isCasualInterviewRequest"
                    type="checkbox"
                    class="boss-input-checkbox"
                    false-value=""
                    data-test="check-only-casual-interview-request"
                  >
                </div>
                <div class="boss-table-3-body">
                  <label
                    for="is-casual-interview-request"
                    class="pega-input"
                  >話を聞きたい応募のみ</label>
                </div>
                <div class="boss-table-3-head margin-left-1">
                  <input
                    id="exclusion-casual-interview-request"
                    v-model="excludeCasualInterviewRequest"
                    type="checkbox"
                    false-value=""
                    class="boss-input-checkbox"
                    data-test="check-exclusion-casual-interview-request"
                  >
                </div>
                <div class="boss-table-3-body">
                  <label
                    for="exclusion-casual-interview-request"
                    class="pega-input"
                  >話を聞きたい応募を除外する</label>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-2 is-boss-only-pc">
                <div class="boss-table-3-head">
                  求人ID
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="conditionJobId"
                    class="boss-input-select"
                    data-test="select-job-ids"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(id, i) in jobIds"
                      :key="i"
                      :value="id"
                    >
                      {{ id }}
                    </option>
                  </select>
                </div>
                <div class="boss-table-3-head padding-left-1">
                  応募した求人
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="equalKeyObject.applicant.job"
                    v-tooltip="{ content: equalKeyObject.applicant.job.name}"
                    class="boss-input-select width-100"
                    data-test="select-applied-jobs"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(job, i) in appliedjobs"
                      :key="i"
                      :value="job"
                      :title="job.name"
                    >
                      {{ job | parseJobName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 grid-x">
                <div class="cell medium-12 large-6 display-flex align-middle pega-table-3-inner-item">
                  <div class="boss-table-3-head">
                    メッセージ予約
                  </div>
                  <div class="boss-table-3-body">
                    <div>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="no-select"
                      >
                        <input
                          v-model="equalKeyObject.applicant.message.isReserved"
                          :value="''"
                          type="radio"
                          class="boss-input-checkbox"
                          data-test="no-select-check"
                        >指定なし
                      </label>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="not-reserved"
                      >
                        <input
                          v-model="equalKeyObject.applicant.message.isReserved"
                          :value="false"
                          type="radio"
                          class="boss-input-checkbox"
                          data-test="not-reserved-check"
                        >予約中を除く
                      </label>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="is-reserved"
                      >
                        <input
                          v-model="equalKeyObject.applicant.message.isReserved"
                          :value="true"
                          type="radio"
                          class="boss-input-checkbox"
                          data-test="is-reserved-check"
                        >予約中のみ
                      </label>
                    </div>
                  </div>
                </div>
                <div class="cell auto display-flex align-middle">
                  <div class="boss-table-3-head">
                    応募・メッセージ
                  </div>
                  <div class="boss-table-3-body">
                    <div>
                      <label
                        v-for="option in messageResponseOptions"
                        :key="option.id"
                        class="pega-entry-list-search-checkbox-label"
                        :data-test="`select-message-${option.id}`"
                      >
                        <input
                          v-model="includeKeyObject.applicant.message.includes"
                          :value="option.status"
                          type="checkbox"
                          class="boss-input-checkbox"
                        >
                        <span>{{ option.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-2">
                <div class="boss-table-3-head">
                  スカウト特典
                </div>
                <div class="boss-table-3-body">
                  <span data-test="special-favor-effective">
                    <label><input
                      v-model="isSpecialFavorEffectiveOnly"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >応募期限内の特典のみ</label>
                  </span>
                  <label
                    v-for="(option ,i) in specialFavorsMaster"
                    :key="i"
                    :data-test="`special-favor-${option.id}`"
                    class="boss-scout-bonus pega-mr-5 pega-input"
                  >
                    <input
                      v-model="checkedSpecialFavorIds"
                      :value="option.id"
                      type="checkbox"
                    >
                    <span class="boss-bonus-check-text boss-bonus-check-mark">{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 is-boss-only-pc">
                <div class="boss-table-3-head">
                  選考フェーズ
                </div>
                <div class="boss-table-3-body">
                  <label
                    v-for="(option, i) in phases"
                    :key="i"
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="`select-phase-${option.id}`"
                  >
                    <input
                      v-model="includeKeyObject.applicant.currentSelection.phaseId.includes"
                      :value="option.id"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 is-boss-only-pc">
                <div class="boss-table-3-head">
                  選考ステータス
                </div>
                <div class="boss-table-3-body">
                  <label
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="'select-status-0'"
                  >
                    <input
                      v-model="includeKeyObject.applicant.currentSelection.statusId.includes"
                      :value="null"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>−</span>
                  </label>
                  <label
                    v-for="(option, i) in statuses"
                    :key="i"
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="`select-status-${option.id}`"
                  >
                    <input
                      v-model="includeKeyObject.applicant.currentSelection.statusId.includes"
                      :value="option.id"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 is-boss-only-pc">
                <div class="boss-table-3-head">
                  評価
                </div>
                <div class="boss-table-3-body">
                  <label
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="'select-evaluation-0'"
                  >
                    <input
                      v-model="includeKeyObject.applicant.currentSelection.evaluation.id.includes"
                      :value="null"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>−</span>
                  </label>
                  <label
                    v-for="(option, i) in evaluationMaster"
                    :key="i"
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="`select-evaluation-${option.id}`"
                  >
                    <input
                      v-model="includeKeyObject.applicant.currentSelection.evaluation.id.includes"
                      :value="option.id"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  人事担当
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="equalKeyObject.applicant.responsibleStaffId"
                    class="boss-input-select width-100"
                    data-test="select-responsible-staffs"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option :value="null">
                      ー
                    </option>
                    <option
                      v-for="staff in responsibles"
                      :key="staff.id"
                      :value="staff.id"
                    >
                      {{ staff.name | parseStaffName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  <input
                    id="duplicated-entry-check"
                    v-model="equalKeyObject.applicant.user.isDuplicatedEntries"
                    type="checkbox"
                    class="boss-input-checkbox"
                    false-value=""
                    data-test="check-duplicated"
                  >
                </div>
                <div class="boss-table-3-body">
                  <label
                    for="duplicated-entry-check"
                    class="pega-input"
                  >重複応募者のみ</label>
                </div>
                <div class="boss-table-3-head margin-left-1">
                  <input
                    id="withdraw-entry-check"
                    v-model="equalKeyObject.applicant.user.isWithdrawal"
                    type="checkbox"
                    false-value=""
                    class="boss-input-checkbox"
                    data-test="check-withdraw"
                  >
                </div>
                <div class="boss-table-3-body">
                  <label
                    for="withdraw-entry-check"
                    class="pega-input"
                  >応募後に退会した会員のみ表示</label>
                </div>
              </div>
            </div>
          </div>
          <div class="is-boss-only-pc">
            <MiniAccordion
              :is-open="false"
              title="さらに絞り込む"
              wrap-class="boss-mini-accordion-plain"
              head-class="boss-mini-accordion-head-custom-2 boss-accordion-head"
            >
              <div class="boss-table-3">
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    現住所
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="prefecturesMaster.length > 0"
                      :master-data="prefecturesMaster"
                      :selected-items="modalSelected('includeKeyObject', 'applicant.user.prefecture.id.includes')"
                      title="都道府県"
                      suffix="current-prefectures"
                      data-test="modal-current-prefectures"
                      @update-modal-checked-ids="updatePrefectures"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    希望勤務地
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="prefecturesMaster.length > 0"
                      :master-data="prefecturesMaster"
                      :selected-items="modalSelected('includeKeyObject', 'applicant.user.desiredWorkPrefectureIds.includes')"
                      title="都道府県"
                      suffix="hope-prefectures"
                      data-test="modal-hope-prefectures"
                      @update-modal-checked-ids="updateHopePrefectures"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    経験職種
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="occupationsMaster.length > 0"
                      :master-data="occupationsMaster"
                      :experience-range-options="occupationExperienceRangeOptions"
                      :default-experience-id="defaultExperienceId"
                      :selected-items="modalSelected('includeIdAndYearKeyObject', 'applicant.user.experienceOccupations.includeIdAndYear')"
                      title="経験職種"
                      suffix="occupations"
                      data-test="modal-occupations"
                      @update-modal-checked-ids="updateOccupations"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    経験業種
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="businessesMaster.length > 0"
                      :master-data="businessesMaster"
                      :selected-items="modalSelected('includeKeyObject', 'applicant.user.experienceBusinessIds.includes')"
                      title="経験業種"
                      suffix="businesses"
                      data-test="modal-businesses"
                      @update-modal-checked-ids="updateBusinesses"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    直近の雇用形態
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model="equalKeyObject.applicant.user.employmentId"
                      class="boss-input-select"
                      data-test="select-employment-pattern"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(option, i) in employmentStatusMaster"
                        :key="i"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    現在の就業状況
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model="equalKeyObject.applicant.user.isWorking"
                      class="boss-input-select"
                      data-test="select-employed"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(option, i) in employedOptions"
                        :key="i"
                        :value="option.value"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    最終学歴学校名
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model="includeKeyObject.applicant.user.lastEducationName.includes"
                      type="text"
                      style="width: 12em;"
                      class="boss-input"
                      data-test="input-school-name"
                    >
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    転職回数
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="rangeKeyObject.applicant.user.jobChangeCount.lte"
                      style="width: 6em;"
                      class="boss-input"
                      data-test="input-job-change-count"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 回以下
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    直近の年収
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="rangeKeyObject.applicant.user.recentSalary.gte"
                      style="width: 6em;"
                      data-test="input-recent-salary-minimum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                    〜
                    <input
                      v-model.number="rangeKeyObject.applicant.user.recentSalary.lte"
                      style="width: 6em;"
                      data-test="input-recent-salary-maximum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    希望の年収
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="rangeKeyObject.applicant.user.desiredSalary.gte"
                      style="width: 6em;"
                      data-test="input-hope-salary-minimum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                    〜
                    <input
                      v-model.number="rangeKeyObject.applicant.user.desiredSalary.lte"
                      style="width: 6em;"
                      data-test="input-hope-salary-maximum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    最終学歴
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model.number="rangeKeyObject.applicant.user.lastEducationId.lte"
                      class="boss-input-select"
                      data-test="select-education"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(education, i) in educationalBackgroundMaster"
                        :key="i"
                        :value="education.id"
                      >
                        {{ education.name }}
                      </option>
                    </select> 以上
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    TOEIC
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="rangeKeyObject.applicant.user.toeic.gte"
                      style="width: 6em;"
                      data-test="input-toeic"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 点以上
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    TOEFL
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="rangeKeyObject.applicant.user.toefl.gte"
                      style="width: 6em;"
                      data-test="input-toefl"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 点以上
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    英語スキル
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model.number="rangeKeyObject.applicant.user.englishSkillId.gte"
                      class="boss-input-select"
                      data-test="select-english-skill"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(englishSkill, i) in languageSkillsMaster"
                        :key="i"
                        :value="englishSkill.id"
                      >
                        {{ englishSkill.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </MiniAccordion>
          </div>
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script>
import Accordion from '@/components/atoms/Accordion'
import MiniAccordion from '@/components/atoms/MiniAccordion'
import _ from 'lodash'
import * as definition from '@/lib/labelValueMappings'
import { now, createDate, dateDiff } from '@/lib/dateUtils.js'
import { mapGetters } from 'vuex'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import DatePicker from 'vue2-datepicker'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    Accordion,
    MiniAccordion,
    SelectModalButton,
    DatePicker
  },
  filters: {
    parseJobName (job) {
      return _.truncate(`${job.id} ${job.name}`, { length: 23 })
    },
    parseStaffName (staffName) {
      return _.truncate(staffName, { length: 13 })
    }
  },
  mixins: [eventValidations],
  props: {
    applicantObjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      matchKeyObject: {
        applicant: {
          user: {
            id: {
              prefix: ''
            }
          }
        }
      },
      equalKeyObject: {
        applicant: {
          user: {
            gender: { id: '' },
            isDuplicatedEntries: '',
            employmentId: '',
            isWorking: '',
            isWithdrawal: ''
          },
          job: '',
          message: {
            isReserved: ''
          },
          responsibleStaffId: '',
          isCasualInterviewRequest: ''
        }
      },
      conditionJobId: '',
      rangeKeyObject: {
        applicant: {
          user: {
            birthday: {
              gte: '',
              lte: ''
            },
            jobChangeCount: {
              lte: ''
            },
            lastEducationId: {
              lte: ''
            },
            englishSkillId: {
              gte: ''
            },
            toefl: {
              gte: ''
            },
            toeic: {
              gte: ''
            },
            recentSalary: {
              gte: '',
              lte: ''
            },
            desiredSalary: {
              gte: '',
              lte: ''
            }
          },
          entryDate: {
            gte: '',
            lte: ''
          }
        }
      },
      fuzzyKeyObject: {
        name: {
          value: '',
          keys: ['user.lastName', 'user.firstName', 'user.lastNameKana', 'user.firstNameKana']
        }
      },
      includeKeyObject: {
        applicant: {
          message: {
            includes: []
          },
          currentSelection: {
            phaseId: { includes: [] },
            statusId: { includes: [] },
            evaluation: {
              id: { includes: [] }
            }
          },
          user: {
            prefecture: {
              id: {
                includes: []
              }
            },
            experienceBusinessIds: {
              includes: []
            },
            desiredWorkPrefectureIds: {
              includes: []
            },
            lastEducationName: {
              includes: ''
            }
          }
        }
      },
      includeIdAndYearKeyObject: {
        applicant: {
          user: {
            experienceOccupations: {
              includeIdAndYear: []
            }
          }
        }
      },
      ageOptions: definition.age,
      messageResponseOptions: definition.messageResponseStatus,
      employedOptions: definition.employed,
      occupationExperienceRangeOptions: definition.applicantOccupationExperienceRange,
      specialFavorOptions: definition.hasSpecialFavorsOrNot,
      checkedSpecialFavorIds: [],
      isSpecialFavorEffectiveOnly: false,
      excludeCasualInterviewRequest: false
    }
  },
  computed: {
    appliedjobs () {
      return this.pickApplicantProperty('job')
    },
    jobIds () {
      return this.pickApplicantProperty('job.id')
    },
    ageGte: {
      get () {
        return dateDiff(now(), createDate(this.rangeKeyObject.applicant.user.birthday.lte), 'year') ?? ''
      },
      set (val) {
        this.rangeKeyObject.applicant.user.birthday.lte = (val) ? now().subtract(val, 'years').format('YYYY-MM-DD') : ''
      }
    },
    ageLte: {
      get () {
        return dateDiff(now(), createDate(this.rangeKeyObject.applicant.user.birthday.gte), 'year') ?? ''
      },
      set (val) {
        this.rangeKeyObject.applicant.user.birthday.gte = (val) ? now().subtract(val + 1, 'years').add(1, 'days').format('YYYY-MM-DD') : ''
      }
    },
    ...mapGetters('settings', [
      'phases',
      'statuses',
      'responsibles'
    ]),
    ...mapGetters([
      'prefecturesMaster',
      'businessesMaster',
      'occupationsMaster',
      'genderMaster',
      'employmentStatusMaster',
      'educationalBackgroundMaster',
      'languageSkillsMaster',
      'evaluationMaster',
      'specialFavorsMaster'
    ]),
    defaultExperienceId () {
      return _.head(this.occupationExperienceRangeOptions).id
    }
  },
  watch: {
    matchKeyObject: {
      handler: 'update',
      deep: true
    },
    equalKeyObject: {
      handler: 'update',
      deep: true
    },
    rangeKeyObject: {
      handler: 'update',
      deep: true
    },
    fuzzyKeyObject: {
      handler: 'update',
      deep: true
    },
    includeKeyObject: {
      handler: 'update',
      deep: true
    },
    includeIdAndYearKeyObject: {
      handler: 'update',
      deep: true
    },
    applicantObjects: {
      handler: 'update'
    },
    checkedSpecialFavorIds: {
      handler: 'update'
    },
    isSpecialFavorEffectiveOnly: {
      handler: 'update'
    },
    conditionJobId: {
      handler: 'update'
    },
    excludeCasualInterviewRequest: {
      handler: 'update'
    }
  },
  methods: {
    update () {
      let filtered = this.filterEqual(this.applicantObjects)
      filtered = this.filterNotCasualInterviewRequest(filtered)
      filtered = this.filterRange(filtered)
      filtered = this.filterFuzzy(filtered)
      filtered = this.filterInclude(filtered)
      filtered = this.filterIdAndYear(filtered)
      filtered = this.filterSpecialFavor(filtered)
      filtered = this.filterMatch(filtered)
      filtered.forEach(applicantObject => {
        applicantObject.isChecked = false
      })
      this.$emit('filteredUpdate', filtered)
    },
    omitEmptyDeep (obj) {
      return _(obj)
        .pickBy(_.isObject)
        .mapValues(this.omitEmptyDeep)
        .omitBy(_.isEmpty)
        .assign(_.omitBy(obj, val => _.isObject(val) || val === ''))
        .value()
    },
    filterMatch (value) {
      const condition = this.omitEmptyDeep(this.matchKeyObject)
      const keys = this.getKeysDeep(condition)
      if (!_.isEmpty(keys)) {
        const funcs = _.overEvery(_.flattenDeep(keys.map(key => {
          const keyValues = _.get(condition, key)
          const result = []
          if (_.has(keyValues, 'prefix')) {
            result.push((value) => {
              const val = _.get(value, key)
              if (_.isNumber(val)) {
                return String(val).match('^' + _.get(keyValues, 'prefix'))
              } else {
                return false
              }
            })
          }
          return result
        })))
        _(value).filter('isShow').forEach(val => {
          val.isShow = funcs(val)
        })
      }
      return value
    },
    filterEqual (value) {
      const condition = this.omitEmptyDeep(this.equalKeyObject)
      _(value).filter(condition).forEach(o => {
        if (this.conditionJobId) {
          o.isShow = o.applicant.job.id === this.conditionJobId
        } else {
          o.isShow = true
        }
      })
      _(value).reject(condition).forEach(o => { o.isShow = false })
      return value
    },
    // 話を聞きたい応募を除外して表示する処理
    filterNotCasualInterviewRequest (value) {
      if (this.excludeCasualInterviewRequest) {
        _(value).filter('isShow').forEach(o => {
          o.isShow = o.applicant.isCasualInterviewRequest === false
        })
      }
      return value
    },
    filterRange (value) {
      const condition = this.omitEmptyDeep(this.rangeKeyObject)
      const keys = this.getKeysDeep(condition)

      if (!_.isEmpty(keys)) {
        const funcs = _.overEvery(_.flattenDeep(keys.map(key => {
          const keyValues = _.get(condition, key)
          const result = []
          if (_.has(keyValues, 'gte')) {
            result.push((value) => {
              const val = _.get(value, key)
              if (_.isNumber(val)) {
                return _.gte(val, _.get(keyValues, 'gte'))
              } else if (_.isNull(val)) {
                return false
              } else {
                return createDate(val)?.isSameOrAfter(createDate(_.get(keyValues, 'gte')), 'day')
              }
            })
          }
          if (_.has(keyValues, 'lte')) {
            result.push((value) => {
              const val = _.get(value, key)
              if (_.isNumber(val)) {
                return _.lte(val, _.get(keyValues, 'lte'))
              } else if (_.isNull(val)) {
                return false
              } else {
                return createDate(val)?.isSameOrBefore(createDate(_.get(keyValues, 'lte')), 'day')
              }
            })
          }
          return result
        })))

        _(value).filter('isShow').forEach(val => {
          val.isShow = funcs(val)
        })
      }
      return value
    },
    getKeysDeep (value, path = '') {
      const keys = _.map(_.keys(value), key => {
        const keyPath = (path === '') ? key : `${path}.${key}`
        if (_.has(_.get(value, key), 'gte') || _.has(_.get(value, key), 'lte') ||
          _.has(_.get(value, key), 'includes') || _.has(_.get(value, key), 'includeIdAndYear') ||
          _.has(_.get(value, key), 'prefix')) {
          return keyPath
        } else {
          return this.getKeysDeep(_.get(value, key), keyPath)
        }
      })
      return _.flattenDeep(keys)
    },
    filterFuzzy (value) {
      const functionArray = _.flattenDeep(_(this.fuzzyKeyObject).values().map(o => {
        const result = []
        if (o.value) {
          result.push((val) => {
            return _(val.applicant).at(o.keys).chunk(2).map(v => this.hiraToKana(v.join(''))).flatten().value().some(val => {
              return _.includes(val, this.hiraToKana(_.replace(o.value, /\s+/g, '')))
            })
          })
        }
        return result
      }).value())
      if (functionArray.length) {
        const funcs = _.overEvery(functionArray)
        _(value).filter('isShow').forEach(val => {
          val.isShow = funcs(val)
        })
      }
      return value
    },
    filterInclude (value) {
      const condition = this.omitEmptyDeep(this.includeKeyObject)
      const keys = this.getKeysDeep(condition)
      if (!_.isEmpty(keys)) {
        const funcs = _.overEvery(_.flattenDeep(keys.map(key => {
          const keyValues = _.get(condition, key)
          const result = []
          if (_.has(keyValues, 'includes')) {
            result.push((value) => {
              const val = _.get(value, key, null)
              const includesValue = _.get(keyValues, 'includes')
              if (_.isArray(val)) {
                return _.some(val, (v) => _.includes(includesValue, v))
              } else if (_.isString(val)) {
                return _.includes(val, includesValue)
              } else if (_.isPlainObject(val)) {
                return _.some(includesValue, (includeObj) => {
                  const includeKey = _.keys(includeObj)[0]
                  return val[includeKey] === includeObj[includeKey]
                })
              } else {
                return _.includes(includesValue, val)
              }
            })
          }
          return result
        })))

        _(value).filter('isShow').forEach(val => {
          val.isShow = funcs(val)
        })
      }
      return value
    },
    filterIdAndYear (value) {
      const condition = this.omitEmptyDeep(this.includeIdAndYearKeyObject)
      const keys = this.getKeysDeep(condition)
      if (!_.isEmpty(keys)) {
        const funcs = _.overEvery(_.flattenDeep(keys.map(key => {
          const keyValues = _.get(condition, key)
          const result = []
          if (_.has(keyValues, 'includeIdAndYear')) {
            result.push((value) => {
              const values = _.get(value, key)
              if (_.isArray(values)) {
                // valuesば応募者のid,experienceYearsのオブジェクトの配列
                return _.some(values, (v) => _.some(_.get(keyValues, 'includeIdAndYear'), (inputValue) => {
                  return !_.has(inputValue, 'experienceYears') || (_.gte(v.experienceYears, inputValue.experienceYears) && _.isEqual(v.id, inputValue.id))
                }))
              }
            })
          }
          return result
        })))

        _(value).filter('isShow').forEach(val => {
          val.isShow = funcs(val)
        })
      }
      return value
    },
    filterSpecialFavor (collection) {
      if (this.checkedSpecialFavorIds.length) {
        _(collection).filter('isShow').reject(obj => {
          return _.some(_.get(obj, 'applicant.approachingStatus.specialFavors', []), value => {
            const result = _.includes(this.checkedSpecialFavorIds, value.id)
            return (this.isSpecialFavorEffectiveOnly) ? value.isEffective && result : result
          })
        }).forEach(v => { v.isShow = false })
      }
      return collection
    },
    hiraToKana (str) {
      return str.replace(/[\u3041-\u3096]/g, function (match) {
        const chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    pickApplicantProperty (path) {
      return _(this.applicantObjects).map('applicant').map(_.property(path)).uniqWith(_.isEqual).value()
    },
    updatePrefectures (data) {
      this.$set(this.includeKeyObject.applicant.user.prefecture.id, 'includes', data.map(x => x.id))
    },
    updateBusinesses (data) {
      this.$set(this.includeKeyObject.applicant.user.experienceBusinessIds, 'includes', data.map(x => x.id))
    },
    updateOccupations (data) {
      this.$set(this.includeIdAndYearKeyObject.applicant.user.experienceOccupations, 'includeIdAndYear', data.map(x => ({ id: x.id, experienceYears: x.experience === '' ? '' : Number(x.experience) })))
    },
    updateHopePrefectures (data) {
      this.$set(this.includeKeyObject.applicant.user.desiredWorkPrefectureIds, 'includes', data.map(x => x.id))
    },
    modalSelected (dataKey, path) {
      return _.get(this[dataKey], path).map(x => (
        {
          id: _.toNumber(_.get(x, 'id', x)),
          experience: _.toString(_.get(x, 'experienceYears', ''))
        }
      ))
    },
    notAfterTodayAndBeforeExpiryDate (date) {
      return date > now() || date <= now().subtract(1, 'years').subtract(1, 'months').subtract(1, 'days')
    }
  }
}
</script>
